export enum Theme {
  Dark = 0,
  Light = 1,
}
